import { FC } from 'react';

interface GenAiIconProps {
    size?: number;
    className?: string;
}

export const GenAiIcon: FC<GenAiIconProps> = ({ size = 20, className = '' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="4" fill="none" />
    </svg>
);

export default GenAiIcon;
